<template>
    <article class="accordions-module" :class="getModuleThemeClass()" v-if="item !== null">
        <h2 v-if="item.Headline != ''" class="accordions-module__headline">{{ item.Headline }}</h2>
        <div v-if="item.RichText != ''" class="accordions-module__rich-text rich-text" v-html="item.RichText"></div>
        <div v-if="item.Accordions.length > 0" class="accordions-module__content accordion__list">
            <div v-for="(accordion, index) in item.Accordions" :key="index" class="accordion__item" data-action="modal-accordion">
                <a :id="(`accordion-item-${index}${item.id}-headline`)" :href="(`#accordion-item-${index}${item.id}-content`)" class="accordion__headline" role="button" aria-expanded="false" :aria-controls="(`#accordion-item-${index}${item.id}-content`)">
                    <h3 class="accordion__headline-inner">
                        {{ accordion.Headline }}
                        <span class="accordion__icon"></span>
                    </h3>
                </a>
                <div :id="(`accordion-item-${index}${item.id}-content`)" class="accordion__content-wrap" aria-hidden="true" :aria-labelledby="(`#accordion-item-${index}${item.id}-headline`)">
                    <div class="accordion__content rich-text" v-html="accordion.RichText"></div>
                </div>
            </div>
        </div>
        <div v-else-if="item.Accordions !== null" class="accordions-module__content accordion__list">
            <div class="accordion__item" data-action="modal-accordion">
                <a id="accordion-item-01-headline" href="#accordion-item-01-content" class="accordion__headline" role="button" aria-expanded="false" aria-controls="#accordion-item-01-content">
                    <h3 class="accordion__headline-inner">
                        {{ item.Accordions.Headline }}
                        <span class="accordion__icon"></span>
                    </h3>
                </a>
                <div id="accordion-item-01-content" class="accordion__content-wrap" aria-hidden="true" aria-labelledby="#accordion-item-01-headline">
                    <div class="accordion__content rich-text" v-html="item.Accordions.RichText"></div>
                </div>
            </div>
        </div>
    </article>
</template>
<script>
import { setupAccordions } from '../../components/accordion';
import { useItem } from '../composables/item';
const { getThemeClass } = useItem();

export default {
    name: 'Accordions',
    props: {
        item: {
            type: Object,
            default: null
        }
    },
    mounted() {
        setTimeout(function() {
            setupAccordions('[data-action="modal-accordion"]');
        }, 1000);
    },
    methods: {
        getModuleThemeClass() {
            return getThemeClass(this.item);
        }
    }
};
</script>
